import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EvaluationCategoryGroupSalaryRange } from '../models/evaluation-category-group-salary-range';

@Injectable({
  providedIn: 'root',
})
export class EvaluationCategoryGroupSalaryRangeService {
  private API_URL = `${environment.apiUrl}/evaluation-category-group-salary-ranges`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<EvaluationCategoryGroupSalaryRange[]> {
    return this.http.get<EvaluationCategoryGroupSalaryRange[]>(this.API_URL);
  }

  getPractices(): Observable<string[]> {
    return this.http.get<string[]>(`${this.API_URL}/practices`);
  }

  /**
   * Replaces the whole Salary Range grid of a practice. Rows not included in the
   * request are removed, so a row deleted in the page stays deleted.
   */
  replaceForPractice(practice: string, rows: EvaluationCategoryGroupSalaryRange[]): Observable<EvaluationCategoryGroupSalaryRange[]> {
    const params = new HttpParams().set('practice', practice);
    return this.http.put<EvaluationCategoryGroupSalaryRange[]>(this.API_URL, { rows }, { params });
  }

  add(range: EvaluationCategoryGroupSalaryRange): Observable<EvaluationCategoryGroupSalaryRange> {
    return this.http.post<EvaluationCategoryGroupSalaryRange>(this.API_URL, range);
  }

  update(id: number, range: EvaluationCategoryGroupSalaryRange): Observable<EvaluationCategoryGroupSalaryRange> {
    return this.http.put<EvaluationCategoryGroupSalaryRange>(`${this.API_URL}/${id}`, range);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }

  /**
   * A row with a null id is a new range, so saving it creates a record; otherwise
   * the existing record is updated.
   */
  save(range: EvaluationCategoryGroupSalaryRange): Observable<EvaluationCategoryGroupSalaryRange> {
    return range.id ? this.update(range.id, range) : this.add(range);
  }
}
